import React, { useEffect, useState } from 'react';
import { useToast } from '../bom/ui/Toast';
import { downloadExport } from './sbomApi';

const FORMATS = [
  { key: 'cyclonedx', label: 'CycloneDX 1.6 (JSON)',
    hint: 'Recommended for the FDA submission. Machine-readable, with the dependency tree, level of support and end of support.' },
  { key: 'vex', label: 'CycloneDX VEX only',
    hint: 'Just your vulnerability statements. Send it after a new vulnerability without re-sending the whole SBOM.' },
  { key: 'spdx', label: 'SPDX 2.3 (JSON)', hint: 'The other format the FDA accepts. Choose it if the reviewer or customer asks for SPDX.' },
  { key: 'xlsx', label: 'Excel', hint: 'Components (one row per occurrence, with its level), Vulnerabilities (assessment and risk), About.' },
  { key: 'csv', label: 'CSV', hint: 'The same table as Excel, as plain text.' },
];

export default function SbomExportModal({ release, onClose, vulnOn = true }) {
  const { showToast } = useToast();
  const [fmt, setFmt] = useState('cyclonedx');
  const [vex, setVex] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const go = async () => {
    setBusy(true);
    setError('');
    try {
      const name = await downloadExport(release.item_id, fmt, vex);
      showToast(`Downloaded ${name}`, 'success');
      onClose();
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="sbom-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <section className="sbom-modal" role="dialog" aria-modal="true" aria-labelledby="sbom-export-title">
        <div className="sbom-modal-head">
          <div>
            <h3 id="sbom-export-title">Export {release.name}</h3>
            <div className="sbom-tiny sbom-muted">{release.components} components · built now from the stored tree</div>
          </div>
          <button type="button" className="sbom-modal-x" aria-label="Close" onClick={onClose}>×</button>
        </div>
        <div className="sbom-modal-body">
          {FORMATS.filter((f) => vulnOn || f.key !== 'vex').map((f) => (
            <button type="button" key={f.key} className={`sbom-opt${fmt === f.key ? ' sbom-opt--on' : ''}`} onClick={() => setFmt(f.key)}>
              <div><b>{f.label}</b><div className="sbom-tiny sbom-muted">{f.hint}</div></div>
            </button>
          ))}
          {vulnOn && fmt === 'cyclonedx' && (
            <label className="sbom-check">
              <input type="checkbox" checked={vex} onChange={(e) => setVex(e.target.checked)} />
              Include the vulnerability statements (embedded VEX): every known vulnerability with your assessment
            </label>
          )}
          {error && <div className="sbom-error" role="alert">{error}</div>}
        </div>
        <div className="sbom-modal-foot">
          <button type="button" className="sbom-btn" onClick={onClose}>Cancel</button>
          <button type="button" className="sbom-btn sbom-btn--pri" onClick={go} disabled={busy}>{busy ? 'Preparing…' : 'Download'}</button>
        </div>
      </section>
    </div>
  );
}
